import { Injectable } from '@angular/core';
import { MediaMessage } from '@models/imported/SagaSchema/MediaMessage';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { CacheService, CacheState } from '@services/cache/cache.service';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';
import { Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { MessagesMenuEntry } from '../../schema/messages-menu-entry';
import { MediaMessagesAvailableService } from '../media-messages/media-messages-available/media-messages-available.service';
import { MediaMessagesNewService } from '../media-messages/media-messages-new/media-messages-new.service';
import { MessageEvent, MessageEventType } from '../media-messages/media-messages/media-messages.service';

@Injectable()
export class MessagesMenuControllerService {
  private messagesMenuEntry: MessagesMenuEntry;

  private messageSub: Subscription = null;

  private mediaMessages: MediaMessage[] = null;

  constructor(
    private myUnitService: MyUnitService,
    private cacheService: CacheService,
    private mediaMessagesAvailableService: MediaMessagesAvailableService,
    private mediaMessagesNewService: MediaMessagesNewService
  ) {}

  setup(messagesMenuEntry: MessagesMenuEntry) {
    this.messagesMenuEntry = messagesMenuEntry;
    this.myUnitService.$unitChanged.subscribe(unitActivity => this.onUnitChanged(unitActivity));
  }

  private onUnitChanged(unitActivity: UnitActivity) {
    if (unitActivity) {
      this.cacheService.state
        .pipe(
          filter(state => state === CacheState.ready),
          first()
        )
        .subscribe(state => this.onCacheReady());
    } else {
      this.mediaMessagesAvailableService.cleanup();
      this.mediaMessagesNewService.cleanup();
    }
  }

  private onCacheReady() {
    this.mediaMessagesAvailableService.setup();
    this.mediaMessagesNewService.setup();
    this.setupMessagesMenuButton();
  }

  private setupMessagesMenuButton() {
    this.messagesMenuEntry.enable();
    this.messagesMenuEntry.onChanged.subscribe(() => this.messagesMenuEntry.clearAttention());

    this.mediaMessages = this.mediaMessagesAvailableService.getMessages();
    this.updateCounter();

    if (this.messageSub === null) {
      this.messageSub = this.mediaMessagesAvailableService.$event.subscribe(event => this.onMessageEvent(event));
    }
  }

  private updateCounter() {
    this.messagesMenuEntry.setCounter(this.mediaMessages.length);
  }

  private onMessageEvent(event: MessageEvent) {
    if (event.type === MessageEventType.added) {
      this.messagesMenuEntry.requireAttention();
    }
    this.updateCounter();
  }
}
